import { Prop } from '@Ravnur-Inc/decorators';
import { Vue } from 'vue-class-component';
import copy from '@Ravnur-Inc/helpers/copy-to-clipboard';

import './embed-code-textarea.scss';

const CN = 'embed-code-textarea';

export default class EmbedCodeTextarea extends Vue {
  @Prop({ type: String, required: true }) code: string;
  @Prop({ type: Boolean, default: true }) canCopy: string;

  render() {
    return (
      <div class={CN}>
        <multiline-field
          autoHeight={true}
          class={`${CN}__field`}
          label={this.$t('media', 'embed__code')}
          readOnly={true}
          value={this.code}
        />

        <action-button
          class={`${CN}__copy`}
          color="primary"
          disabled={!this.canCopy}
          mode="borderless"
          process={this.copyCode}
        >
          <l10n group="media" tkey="embed__copy" />
        </action-button>
      </div>
    );
  }

  private copyCode() {
    copy(this.code);
    return new Promise((resolve) => setTimeout(resolve, 500));
  }
}
